<template>
  <div class="ExamList">
    <TopNavBar navtitle="上传视频"></TopNavBar>
    <div class="enrolllist">
      <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        finished-text="没有更多了"
        @load="onLoad"
        :offset="10"
      >
        <van-cell v-for="item in MyExamForm" :key="item.EF_ID">
          <ul class="examinfo">
            <h1>{{ item.ExamBatch.EB_Name }}</h1>
            <img class="papers" :src="item.Photo" :alt="item.Name" />
            <li>
              <label for="">姓名：</label>
              <span>{{ item.Name }}</span>
            </li>
            <li>
              <label for="">准考证号：</label>
              <span>{{ item.ExamNO }}</span>
            </li>
            <li>
              <label for="">专业：</label>
              <span class="warning">{{ item.Majors.MName }}</span>
            </li>
            <li>
              <label for="">级别：</label>
              <span class="warning">{{ item.Grades.GName }}</span>
            </li>
            <li v-if="item.MID == 9 && item.IsSubAnswer == 1">
              <label for="">答题记录：</label>
              <span class="primary">已提交</span>
            </li>
            <li class="btn-gather">
              <van-button
                type="warning"
                v-if="item.MID != 9 && item.IsSubAnswer == 0"
                size="small"
                :to="'/ExamOnline?EF_ID=' + item.EF_ID"
                ><i class="iconfont icon-shangchuanshipin1"></i
                >上传视频</van-button
              >
              <van-button
                type="primary"
                v-if="item.MID != 9 && item.IsSubAnswer == 1"
                size="small"
                :to="'/ExamOnline?EF_ID=' + item.EF_ID"
                ><i class="iconfont icon-shipin1"></i>查看视频</van-button
              >
              <van-button
                type="warning"
                v-if="item.MID == 9"
                size="small"
                :to="'/Answerkey?EF_ID=' + item.EF_ID + '&IsTest=0'"
                ><i class="iconfont icon-shipin1"></i>听力考试</van-button
              >
              <van-button
                type="primary"
                v-if="item.MID == 9 && item.ExamBatch.HearingTestState == 1"
                size="small"
                :to="'/Answerkey?EF_ID=' + item.EF_ID + '&IsTest=1'"
                ><i class="iconfont icon-shipin1"></i>听力练习</van-button
              >
              <!-- <van-button type="primary" size="small" to="/ExamResultInfo"><i class="iconfont icon-zhuanye"></i>成绩查询</van-button> -->
              <van-button
                type="info"
                size="small"
                :to="'/EnrollDetails?EF_ID=' + item.EF_ID"
              >
                <i class="iconfont icon-xiangqing"></i>报名详情
              </van-button>
            </li>
          </ul>
        </van-cell>
      </van-list>
      <div class="no-data" v-if="!this.MyExamForm || MyExamForm.length == 0">
        <van-empty description="没有查询到您的报名信息" />
      </div>
    </div>
    <van-overlay :show="showload">
      <van-loading size="50px" vertical class="wrapper">加载中...</van-loading>
    </van-overlay>
  </div>
</template>

<script>
import TopNavBar from "@/components/TopNavBar.vue";
import { GetMyOnlineExamList } from "@/api/exam";
const defaultQuery = {
  PageIndex: 1,
  PageSize: 10
};
export default {
  components: {
    TopNavBar
  },
  data() {
    return {
      MyExamForm: [],
      query: Object.assign({}, defaultQuery),
      total: 0, //总共的数据条数
      loading: false,
      finished: false,
      showload: true
    };
  },
  created() {
    this.GetMyOnlineExamList();
  },
  methods: {
    GetMyOnlineExamList() {
      GetMyOnlineExamList(this.query)
        .then(res => {
          let rows = res.listData; //请求返回当页的列表

          this.loading = false;
          this.total = res.totalCount;
          let that = this;
          if (rows == null || rows.length === 0) {
            // 加载结束
            this.finished = true;
            setTimeout(function() {
              that.showload = false;
            }, 2000);
            return;
          }
          // 数据合并
          this.MyExamForm = this.MyExamForm.concat(rows);
          if (this.MyExamForm.length >= this.total) {
            this.finished = true;
          }
          setTimeout(function() {
            that.showload = false;
          }, 2000);
        })
        .catch(() => {
          let that = this;
          setTimeout(function() {
            that.query.PageIndex--;
            that.loading = false;
            that.showload = false;
          }, 2000);
        });
    },
    //滚动加载时触发，
    onLoad() {
      this.query.PageIndex++;
      this.GetMyOnlineExamList();
    }
  }
};
</script>

<style></style>
